const navConfig = [
  { id: 0, path: '/', label: 'Dashboard' }
]

export { navConfig }